import { Link } from 'react-router-dom';
import {
    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper, Pagination, Box, IconButton, Typography
} from '@mui/material';
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';

const PermissionProfileTable = ({ profiles, total, page, limit, setPage, onEdit, onDelete }) => {
    return (
        <Box sx={{ display: 'flex', flexDirection: 'column', height: '100%' }}>
            <TableContainer
                component={Paper}
                sx={{ minWidth: 1000, overflow: 'auto', flex: 1, borderRadius: 0, boxShadow: 'none' }}
            >
                <Table stickyHeader size="small">
                    <TableHead>
                        <TableRow>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>שם פרופיל</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>הרשאות מוצר</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>הרשאות אדמין</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>סיריאלים מקושרים</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>משתמשים מקושרים</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>תאריך יצירה</TableCell>
                            <TableCell sx={{ fontWeight: 'bold', backgroundColor: '#f0f0f0' }}>פעולות</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {profiles.map((profile) => (
                            <TableRow key={profile._id}>
                                <TableCell>{profile.name}</TableCell>
                                <TableCell>{profile.permissions?.product?.features?.length || 0}</TableCell>
                                <TableCell>{profile.permissions?.admin?.rules?.length || 0}</TableCell>

                                {/* סיריאלים מקושרים */}
                                <TableCell>
                                    {profile.serialsCount > 0 ? (
                                        <Typography
                                            variant="body2"
                                            color="primary"
                                            component={Link}
                                            to={`/access-serial?permissionProfile=${profile._id}`}
                                            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                            {profile.serialsCount}
                                        </Typography>
                                    ) : (
                                        '—'
                                    )}
                                </TableCell>

                                {/* משתמשים מקושרים */}
                                <TableCell>
                                    {profile.usersCount > 0 ? (
                                        <Typography
                                            variant="body2"
                                            color="primary"
                                            component={Link}
                                            to={`/customers?permissionProfile=${profile._id}`}
                                            sx={{ textDecoration: 'underline', cursor: 'pointer' }}
                                        >
                                            {profile.usersCount}
                                        </Typography>
                                    ) : (
                                        '—'
                                    )}
                                </TableCell>

                                <TableCell>
                                    {new Date(profile.createdAt).toLocaleString('he-IL', {
                                        timeZone: 'Asia/Jerusalem',
                                        year: 'numeric',
                                        month: '2-digit',
                                        day: '2-digit',
                                        hour: '2-digit',
                                        minute: '2-digit',
                                    })}
                                </TableCell>

                                <TableCell>
                                    <IconButton onClick={() => onEdit(profile)}>
                                        <EditIcon />
                                    </IconButton>
                                    <IconButton
                                        onClick={() => onDelete(profile)}
                                        sx={{ color: 'red' }}
                                        disabled={profile.usersCount > 0 || profile.serialsCount > 0}
                                    >
                                        <DeleteIcon />
                                    </IconButton>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>

            <Box mt={0} py={1} display="flex" justifyContent="center">
                <Pagination
                    count={Math.ceil(total / limit)}
                    page={page}
                    onChange={(e, val) => setPage(val)}
                    color="primary"
                />
            </Box>
        </Box>
    );
};

export default PermissionProfileTable;
